import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { housekeepingQueryKeys as t } from "../housekeeping/useHousekeepingQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { roomsApi as i } from "@maat/api-main";
//#region src/rooms/useUpdateRoomMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ roomId: e, ...t }) => i.updateRoom(e, t),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.property() }), a.invalidateQueries({ queryKey: e.room() }), a.invalidateQueries({ queryKey: e.unit() }), a.invalidateQueries({ queryKey: t.board() }), a.invalidateQueries({ queryKey: t.attention() });
		}
	});
};
//#endregion
export { a as useUpdateRoomMutation };
